/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 1c70d1ef2eba8c9fed49d31f6ff0a4c9bda9c00ec71e936ea62e95f26b69f1ec
 */
import {
  tag_colorTagBlueBackground,
  tag_colorTagBlueBackgroundHover,
  tag_colorTagBlueText,
  tag_colorTagBlueTextHover,
  tag_colorTagDefaultBackground,
  tag_colorTagDefaultBackgroundHover,
  tag_colorTagDefaultText,
  tag_colorTagDefaultTextHover,
  tag_colorTagHighlightBackground,
  tag_colorTagHighlightBackgroundHover,
  tag_colorTagHighlightText,
  tag_colorTagHighlightTextHover,
  tag_colorTagNewBackground,
  tag_colorTagNewBackgroundHover,
  tag_colorTagNewText,
  tag_colorTagNewTextHover,
  tag_colorTagPendingBackground,
  tag_colorTagPendingBackgroundHover,
  tag_colorTagPendingText,
  tag_colorTagPendingTextHover,
  tag_colorTagSevereBackground,
  tag_colorTagSevereBackgroundHover,
  tag_colorTagSevereText,
  tag_colorTagSevereTextHover,
} from 'ext-ui/style/colors'
import {
  pill_pillCornerRadius,
  spacing,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_2xl,
  font_size_sm,
  font_size_xs,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  align-items: center;
  border-radius: ${pill_pillCornerRadius};
  display: inline-flex;
  font-family: ${font_family_weight_regular};
  font-family: ${font_family_weight_medium};
  gap: ${spacing(1)};
  justify-content: center;

  &.large {
    font-size: ${font_size_2xl};
    line-height: 24px;
    padding-block: ${spacing(1)};
    padding-inline: ${spacing(2)};
  }

  &.medium {
    font-size: ${font_size_sm};
    height: ${spacing(5)};
    line-height: 16px;
    padding-inline: ${spacing(1)};
  }

  &.small {
    font-size: ${font_size_xs};
    line-height: 14px;
    padding-inline: ${spacing(1)};
  }

  &.aiNew {
    background: ${tag_colorTagNewBackground};
    color: ${tag_colorTagNewText};

    &:hover {
      background: ${tag_colorTagNewBackgroundHover};
      color: ${tag_colorTagNewTextHover};
    }
  }

  &.default {
    background: ${tag_colorTagDefaultBackground};
    color: ${tag_colorTagDefaultText};

    &:hover {
      background: ${tag_colorTagDefaultBackgroundHover};
      color: ${tag_colorTagDefaultTextHover};
    }
  }

  &.highlight {
    background: ${tag_colorTagHighlightBackground};
    color: ${tag_colorTagHighlightText};

    &:hover {
      background: ${tag_colorTagHighlightBackgroundHover};
      color: ${tag_colorTagHighlightTextHover};
    }
  }

  &.pending {
    background: ${tag_colorTagPendingBackground};
    color: ${tag_colorTagPendingText};

    &:hover {
      background: ${tag_colorTagPendingBackgroundHover};
      color: ${tag_colorTagPendingTextHover};
    }
  }

  &.saas {
    background: ${tag_colorTagBlueBackground};
    color: ${tag_colorTagBlueText};

    &:hover {
      background: ${tag_colorTagBlueBackgroundHover};
      color: ${tag_colorTagBlueTextHover};
    }
  }

  &.severe {
    background: ${tag_colorTagSevereBackground};
    color: ${tag_colorTagSevereText};

    &:hover {
      background: ${tag_colorTagSevereBackgroundHover};
      color: ${tag_colorTagSevereTextHover};
    }
  }
`
